import {ReactNode} from 'react';

interface CLIssues {
  items: CLIssuesMessage[];
  customMessage?: string;
}

interface CLIssuesMessage {
  level: CLIssueLevel;
  subject?: string;
  message?: string;
  description?: ReactNode;
}

enum CLIssueLevel {
  Error = 0,
  Warning = 10,
  Info = 20,
  Success = 30,
}

enum CLIssueName {
  Error = 'Error',
  Warning = 'Warning',
  Info = 'Info',
  Success = 'Success',
}

export {CLIssueLevel, CLIssues, CLIssuesMessage, CLIssueName};
